import React, { useEffect } from "react";
import { Link } from "gatsby";
import '../../sass/components/_components.header.scss';
import { StaticImage } from 'gatsby-plugin-image';
import useDynamicRefs from 'use-dynamic-refs';
// import iconPatternFive from '../../images/perform-2023-pattern5.svg';

const scrollToRef = (ref) => {
    if (ref) {
        window.scrollTo({
            top: document.querySelector(ref).offsetTop,
            left: 0,
            behavior: 'smooth'
        });
    }
}

const HeaderPerformLatest = ({ classCheck }) => {
    // const [hamburgeractiveElement, hamburgersetActiveElement] = useState(null);
    const [getRef, setRef] = useDynamicRefs();

    const hamburgerClick = (index) => {
        getRef(index).current.nextElementSibling.classList.toggle('is-active');
        getRef(index).current.classList.toggle('is-active');
    };

    useEffect(() => {

    }, [hamburgerClick])

    return (
        <>
            <header className={`cp-header l--perform l--classCheck${classCheck} l--classCheckperform`}>
                <div className="cp-header__inner l--flex">
                    <div className="cp-header__left l--flex">
                        {/* <div className="l--absolute l--abolutePattern">
                            <img src={iconPatternFive} alt="" />
                        </div> */}
                        <Link to={`/`}>
                            <StaticImage src='../../images/perform2023-logo.svg' alt="Planful" />
                        </Link>
                    </div>
                    <div className="cp-header__right l--flex">
                        <nav ref={setRef('hamburgerOpen')} className={`cp-header__right-performnav`}>
                            {classCheck === 'perform-marketing' &&
                                <>
                                    <button onClick={() => scrollToRef(`.cp-perform2023Grid`)} className="cp-blogScrollSections">About</button>
                                    <button onClick={() => scrollToRef(`.cp-perform2023Agenda`)} className="cp-blogScrollSections">Schedule</button>
                                </>
                                // :
                                // <>
                                //     <button onClick={() => scrollToRef(`.cp-perform2023Grid`)} className="cp-blogScrollSections">About</button>
                                //     <button onClick={() => scrollToRef(`.cp-perform2023Video`)} className="cp-blogScrollSections">Why Attend</button>
                                //     <button onClick={() => scrollToRef(`.cp-perform2023Speakers`)} className="cp-blogScrollSections">Speakers</button>
                                //     <button onClick={() => scrollToRef(`.cp-perform2023Embed`)} className="cp-blogScrollSections">Schedule</button>
                                // </>
                            }
                        </nav>
                        {classCheck === 'perform-marketing' &&
                            <>
                                <button aria-label="Click icon to open navigation" className="cp-booktoggle__hamburger l-performHamburger js-hamburger-toggle" onClick={() => hamburgerClick('hamburgerOpen')} aria-live="polite">
                                    <span className="visually-hidden l-nav"></span>
                                    <span className="cp-booktoggle__hamburger--icon js-hamburger-child">
                                        <span></span><span></span><span></span><span></span><span></span><span></span>
                                    </span>
                                </button>
                                <div className="l-relativeButton">
                                    <a className="l-button" href="https://hopin.com/events/perform-2023" target="_blank" rel="noreferrer">Register</a>
                                    <a className="l-button l-backgroundHover" href="https://hopin.com/events/perform-2023" target="_blank" rel="noreferrer">Register</a>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </header>
        </>
    )
}

export default HeaderPerformLatest;